// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2nsVd","validationTips":"StatementDescriptor_validationTips__EihbA"};